import React from "react";
import { Heart, Feather, Sun, Quote } from "lucide-react";

const Storyteller = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Mystical Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-black to-orange-900">
        {/* Animated spiritual overlay */}
        <div className="absolute inset-0 bg-gradient-to-tr from-yellow-500/10 via-purple-500/20 to-orange-500/15 animate-pulse" style={{animationDuration: '5s'}} />
        
        {/* Sacred geometry */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-16 left-16 w-40 h-40 border-2 border-yellow-400" style={{clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)', transform: 'rotate(0deg)', animation: 'spin 30s linear infinite'}} />
          <div className="absolute top-32 right-20 w-32 h-32 border border-orange-400 rounded-full animate-pulse" style={{animationDuration: '4s'}} />
          <div className="absolute bottom-40 left-32 w-36 h-36 border border-purple-400" style={{transform: 'rotate(45deg)', animationDuration: '25s'}} />
        </div>
        
        {/* Floating spiritual elements */}
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-yellow-400 rounded-full opacity-60 animate-bounce" style={{animationDelay: '0s'}} />
          <div className="absolute top-1/3 right-1/3 w-3 h-3 bg-orange-400 rounded-full opacity-50 animate-bounce" style={{animationDelay: '1s'}} />
          <div className="absolute bottom-1/3 left-1/3 w-5 h-5 bg-purple-400 rounded-full opacity-40 animate-bounce" style={{animationDelay: '2s'}} />
          
          {/* Energy particles */}
          <div className="absolute top-20 right-32 text-2xl text-yellow-400/30 animate-pulse" style={{animationDuration: '3s'}}>✦</div>
          <div className="absolute bottom-32 left-20 text-xl text-orange-400/40 animate-pulse" style={{animationDuration: '4s'}}>☆</div>
          <div className="absolute top-1/2 right-16 text-3xl text-purple-400/30 animate-pulse" style={{animationDuration: '5s'}}>◆</div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-3 mb-6">
            <Feather size={24} className="text-gray-600" />
            <span className="text-sm uppercase tracking-widest text-gray-500 font-light">
              The Storyteller Within
            </span>
            <Feather size={24} className="text-gray-600" />
          </div>
          <h2 className="text-5xl lg:text-6xl font-light tracking-tight mb-6">
            <span className="bg-gradient-to-r from-white via-yellow-300 to-orange-400 bg-clip-text text-transparent">
              Meet 
            </span>
            <span className="italic font-normal bg-gradient-to-r from-orange-400 via-red-400 to-yellow-400 bg-clip-text text-transparent animate-pulse drop-shadow-2xl">
              "Keeper Of The Fiyah!"
            </span>
            <div className="absolute -inset-2 bg-gradient-to-r from-orange-500/10 via-red-500/10 to-yellow-500/10 blur-xl -z-10 animate-pulse" />
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Content */}
          <div className="space-y-8 order-2 lg:order-1">
            {/* Main Story */}
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <Quote size={24} className="text-yellow-400 mt-1 flex-shrink-0" />
                <div className="space-y-4">
                  <p className="text-lg leading-relaxed font-light italic">
                    <span className="bg-gradient-to-r from-orange-200 via-yellow-300 to-orange-300 bg-clip-text text-transparent">
                      A wombman who was <span className="font-medium bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent">INSPIYAHED</span> to get her shit together, 
                      entering the <span className="font-medium bg-gradient-to-r from-purple-300 to-orange-400 bg-clip-text text-transparent">1010 transformation portal</span>, disconnecting and 
                      reconnecting to YAH spirit in a whole new way!
                    </span>
                  </p>
                  
                  <p className="text-lg leading-relaxed font-light">
                    <span className="bg-gradient-to-r from-orange-200 via-yellow-300 to-orange-300 bg-clip-text text-transparent">
                      My skin may be copper colored but my blood is red and we relate more than we disagree.
                    </span>
                  </p>

                  <p className="text-lg leading-relaxed font-light">
                    <span className="bg-gradient-to-r from-orange-200 via-yellow-300 to-orange-300 bg-clip-text text-transparent">
                      I AM thrilled to have you join me in the movement towards abundance, prosperity and balance. 
                      Embrace the power of the positive towards{" "}
                      <span className="font-medium bg-gradient-to-r from-yellow-300 via-orange-400 to-red-400 bg-clip-text text-transparent tracking-wide">
                        <strong>YAH HEALTH WEALTH HAPPINESS</strong>© (<strong>YHWH יהוה</strong>) The Universal Pillars Of Success.
                      </span>.
                    </span>
                  </p>
                </div>
              </div>
            </div>

            {/* Ancient Principles */}
            <div className="bg-white/80 backdrop-blur-sm border border-gray-200 rounded-lg p-8 shadow-sm">
              <div className="flex items-center space-x-3 mb-4">
                <Sun size={20} className="text-gray-600" />
                <h3 className="text-xl font-light text-black tracking-wide">
                  Ancient Principles:
                </h3>
              </div>
              <blockquote className="text-gray-700 font-light leading-relaxed italic border-l-2 border-gray-300 pl-4">
                "You are my witness declares YHWH יהוה, yes my servant whom I have chosen, 
                so that you may know and have faith in me........."
              </blockquote>
              <cite className="text-sm text-gray-500 font-light mt-3 block">
                — Isaiah 43:10
              </cite>
            </div>
          </div>

          {/* Visual Element */}
          <div className="order-1 lg:order-2 relative">
            <div className="aspect-square bg-gradient-to-br from-purple-900/80 via-black/80 to-orange-900/80 rounded-2xl relative overflow-hidden shadow-2xl border border-yellow-400/20">
              {/* Your artwork as background */}
              <div className="absolute inset-0 opacity-40">
                <img 
                  src="https://customer-assets.emergentagent.com/job_aligned-kotf/artifacts/7cpvewhu_Yahffirmations%20-%20KOTF888.png" 
                  alt="Keeper Of The Fiyah Artwork"
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>

              {/* Mystical overlay effects */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-3/4 h-3/4 relative">
                  {/* Sacred circles */}
                  <div className="absolute inset-0 rounded-full border-2 border-yellow-400/30 animate-spin" style={{animationDuration: '20s'}} />
                  <div className="absolute inset-4 rounded-full border border-orange-400/40 animate-spin" style={{animationDuration: '15s', animationDirection: 'reverse'}} />
                  <div className="absolute inset-8 rounded-full border border-purple-400/30 animate-pulse" style={{animationDuration: '4s'}} />
                  
                  {/* Center spiritual symbol */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-2xl font-light bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent italic animate-pulse">
                      FLY FREQUENCY
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating energy particles */}
              <div className="absolute top-8 left-8 w-3 h-3 bg-yellow-400 rounded-full animate-bounce opacity-80" style={{animationDelay: '0.5s'}} />
              <div className="absolute top-12 right-12 w-2 h-2 bg-orange-400 rounded-full animate-bounce opacity-70" style={{animationDelay: '1s'}} />
              <div className="absolute bottom-16 left-12 w-4 h-4 bg-purple-400 rounded-full animate-bounce opacity-60" style={{animationDelay: '1.5s'}} />
              <div className="absolute bottom-8 right-8 w-2 h-2 bg-red-400 rounded-full animate-bounce opacity-80" style={{animationDelay: '2s'}} />
              
              {/* Sacred numbers */}
              <div className="absolute top-4 right-4 text-yellow-400/50 text-sm font-light animate-pulse">
                888
              </div>
            </div>

            {/* Portal badge */}
            <div className="absolute -bottom-4 -left-4 bg-white shadow-lg rounded-lg p-4 border border-gray-100">
              <div className="text-center">
                <div className="text-xs uppercase tracking-widest text-gray-500 mb-1">
                  Transformation
                </div>
                <div className="text-sm font-light text-black tracking-wide">
                  1010 Portal
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Storytelling Mission */}
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-br from-black via-purple-900/80 to-orange-900/80 text-white rounded-2xl p-12 relative overflow-hidden border-2 border-yellow-400/30 shadow-2xl">
            {/* Sacred geometry background */}
            <div className="absolute inset-0 opacity-20">
              <div className="absolute top-4 left-4 w-12 h-12 border-2 border-yellow-400 rotate-45 animate-spin" style={{animationDuration: '15s'}} />
              <div className="absolute top-8 right-8 w-8 h-8 border border-orange-400 rounded-full animate-pulse" style={{animationDuration: '3s'}} />
              <div className="absolute bottom-4 left-8 w-10 h-10 border border-purple-400 rotate-45" />
              <div className="absolute bottom-8 right-4 w-6 h-6 border border-red-400 rounded-full animate-bounce" style={{animationDelay: '1s'}} />
              
              {/* Energy lines */}
              <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-yellow-400/30 to-transparent" />
              <div className="absolute top-0 left-1/2 w-px h-full bg-gradient-to-b from-transparent via-orange-400/30 to-transparent" />
            </div>

            <div className="relative z-10">
              <div className="flex items-center justify-center space-x-3 mb-6">
                <Heart size={24} className="text-yellow-400 animate-pulse" />
                <h3 className="text-3xl font-light tracking-wide">
                  <span className="bg-gradient-to-r from-yellow-300 via-orange-400 to-red-400 bg-clip-text text-transparent">
                    Where Stories Meet Spirit
                  </span>
                </h3>
                <Heart size={24} className="text-orange-400 animate-pulse" />
              </div>
              
              <p className="text-lg font-light leading-relaxed mb-8">
                Through <span className="italic bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent font-medium">FLY FREQUENCY - Faith.Love.Yah</span>, I bridge the gap between personal transformation and 
                professional innovation. Every digital transformation story begins with a human story—a journey 
                of growth, challenge, and breakthrough.
              </p>
              
              <div className="grid md:grid-cols-4 gap-6 text-center">
                <div className="group hover:scale-105 transition-transform duration-300">
                  <div className="text-4xl font-light mb-2 bg-gradient-to-b from-purple-300 to-purple-400 bg-clip-text text-transparent group-hover:from-purple-200 group-hover:to-purple-300 transition-colors">
                    Yah
                  </div>
                  <div className="text-sm text-purple-200 font-light">Spiritual Foundation & Faith</div>
                </div>
                <div className="group hover:scale-105 transition-transform duration-300">
                  <div className="text-4xl font-light mb-2 bg-gradient-to-b from-green-300 to-green-400 bg-clip-text text-transparent group-hover:from-green-200 group-hover:to-green-300 transition-colors">
                    Health
                  </div>
                  <div className="text-sm text-green-200 font-light">Wellness & Mental Clarity</div>
                </div>
                <div className="group hover:scale-105 transition-transform duration-300">
                  <div className="text-4xl font-light mb-2 bg-gradient-to-b from-yellow-300 to-orange-400 bg-clip-text text-transparent group-hover:from-yellow-200 group-hover:to-orange-300 transition-colors">
                    Wealth
                  </div>
                  <div className="text-sm text-orange-200 font-light">Abundance & Prosperity</div>
                </div>
                <div className="group hover:scale-105 transition-transform duration-300">
                  <div className="text-4xl font-light mb-2 bg-gradient-to-b from-pink-300 to-red-400 bg-clip-text text-transparent group-hover:from-pink-200 group-hover:to-red-300 transition-colors">
                    Happiness
                  </div>
                  <div className="text-sm text-pink-200 font-light">Joy & Life Balance</div>
                </div>
              </div>

              {/* Sacred number */}
              <div className="mt-8 text-6xl font-ultralight text-yellow-400/30 animate-pulse" style={{animationDuration: '4s'}}>
                888
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Storyteller;